import {InjectionToken} from '@angular/core';

/**
 * Configuration interface for EPG Authenticator Middleware
 */
export interface EpgAuthenticatorConfig {
  /**
   * The authentication/login URL to redirect to when a 403 error occurs
   */
  authenticationUrl: string;
}

/**
 * Injection token for EPG Authenticator Middleware configuration
 *
 * @example
 * ```typescript
 * // In your app config or providers:
 * {
 *   provide: EPG_AUTHENTICATOR_CONFIG,
 *   useValue: {
 *     authenticationUrl: environment.authenticationUrl
 *   }
 * }
 * ```
 */
export const EPG_AUTHENTICATOR_CONFIG =
  new InjectionToken<EpgAuthenticatorConfig>('EPG_AUTHENTICATOR_CONFIG', {
    providedIn: 'root',
    factory: () => ({
      authenticationUrl: getAuthenticationUrlFromEnv(),
    }),
  });

/**
 * Gets the authentication URL from environment variables
 */
function getAuthenticationUrlFromEnv(): string {
  // Check for browser environment variable (set via build process)
  if (typeof window !== 'undefined' && (window as any).__EPG_AUTH_URL__) {
    return (window as any).__EPG_AUTH_URL__;
  }

  return '';
}
